var map = {
	"./404.svg": 8016,
	"./bug.svg": 9702,
	"./chart.svg": 6360,
	"./clipboard.svg": 6490,
	"./component.svg": 8669,
	"./dashboard.svg": 119,
	"./documentation.svg": 5182,
	"./drag.svg": 1537,
	"./edit.svg": 2724,
	"./email.svg": 5176,
	"./example.svg": 5018,
	"./excel.svg": 3353,
	"./eye.svg": 9983,
	"./form.svg": 7026,
	"./guide 2.svg": 7130,
	"./guide.svg": 8312,
	"./icon.svg": 4587,
	"./international.svg": 5052,
	"./language.svg": 3462,
	"./link.svg": 3792,
	"./list.svg": 5752,
	"./lock.svg": 7253,
	"./message.svg": 1541,
	"./money.svg": 4852,
	"./nested.svg": 6873,
	"./password.svg": 691,
	"./people.svg": 5793,
	"./peoples.svg": 5808,
	"./qq.svg": 242,
	"./shopping.svg": 3524,
	"./size.svg": 5163,
	"./star.svg": 4128,
	"./tab.svg": 5997,
	"./table.svg": 7940,
	"./theme.svg": 591,
	"./tree.svg": 5304,
	"./user.svg": 1089,
	"./wechat.svg": 8370,
	"./zip.svg": 9293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3810;